export default __webpack_public_path__ + "static/media/financial-independence.cd4acdef.webp";